export const isCallNotification = (message) => {
    return (message.method !== undefined && message.method === 'call');
};
//# sourceMappingURL=/build/es2018/guards/call-notification.js.map